import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringToArrary',
  standalone: true
})
export class StringToArraryPipe implements PipeTransform {

  transform(value?: string): string[] {
    if (!value) return [];

    return value.split(",");
  }

}
